export const EVENTS = {
  INCREMENT_RPM: 'INCREMENT_RPM',
  DECREREMENT_RPM: 'DECREREMENT_RPM',
  INCREMENT_TIME: 'INCREMENT_TIME',
  DECREMENT_TIME: 'DECREMENT_TIME',
};

export const RPM_UPDATE_RATE = 1000;
export const TIME_UPDATE_RATE = 10;
export const FUNTION_CALL_INTERVAL = 500;
export const PULSE_TIME = new Date(2000, 1, 1, 0, 0, 30);

export function formatView(value) {
  const MIN_VALUE = 10;
  if (value < MIN_VALUE) return `0${value}`;
  else return value;
}
